import React, {useState,useEffect} from 'react'
import DropzoneComponent from 'react-dropzone-component'
import { Button } from 'semantic-ui-react'

export default function DropzoneSingleImage(props) {

	function SetFileImage(file){
		  props.data(file);
	}
	function SetFilePath(file){
		  props.path(file);
	}

	 var myDropzone;
	 const [dropmessage, setdropmessage]       = useState(true);
	 const [configDropzone, setconfigDropzone] = useState(null);
	 function initCallback (dropzone) {
		 myDropzone = dropzone;
		 setconfigDropzone(dropzone);
	 }
	 function removeFile (file) {
		 if (myDropzone) {
				 myDropzone.removeFile(file);
		 }
	 }
	 function disableDropzone(){
		 myDropzone.removeEventListeners();
	 }
	 function enableDropzone(){
		 myDropzone.setupEventListeners();
	 }
	 let componentConfig = {
		 postUrl: 'no-url',
		 addRemoveLinks:true,
	 }

	 let djsConfig = {
		 acceptedFiles : 'image/jpeg, images/jpg, image/png',
		 addRemoveLinks:true,
		 autoProcessQueue: false,
		 parallelUploads : 1,
		 maxFiles:1,
	 }

	 let eventHandlers = {
		 init: function(dropzone) {

				 initCallback(dropzone);



				 if(props.mockdata.file_name!=''){
					 var mockFile = { name: props.mockdata.file_name, size: 12345, accepted:true, status:'added' };
					 dropzone.options.addedfile.call(dropzone, mockFile);
					 dropzone.options.thumbnail.call(dropzone, mockFile, props.mockdata.file_url);
					 dropzone.options.complete.call(dropzone, mockFile);
					 setdropmessage(false);
					 disableDropzone();
				 }


		 },
		 addedfile(file){
				 setdropmessage(false);
				 SetFileImage(file);
				 myDropzone.on("thumbnail", function(file){
					SetFilePath(file.dataURL);
				 });
		 },
		 maxfilesexceeded(file){
				 setdropmessage(false);
				 removeFile(file);
				 disableDropzone();
		 },
		 removedfile(file){
				 if(myDropzone.getQueuedFiles().length==0){
					 setdropmessage(true);
					 SetFileImage('');
					 enableDropzone();
					 SetFilePath('no_image');
					 //setavatar(tempavatar);
				 }
				 if(file.status=='added'){
					 //SetFileImage('');
				 }
		 },
		 sending(file, xhr, formData) {
				 formData.append('type', 'uploadfile');
		 },
		 error(errorMessage){
			 //console.log(errorMessage);
		 }
	}



	return (
		<React.Fragment>
			<DropzoneComponent
				 className="dropzone"
				 config={componentConfig}
				 eventHandlers={eventHandlers}
				 djsConfig={djsConfig}
				 >
				 {dropmessage&&<div className="dz-message" data-dz-message>
							<div className="dropIcon"><i className="uil-image"></i></div>
							<div className="dropText">Drop or click image here to upload</div>
				 </div>}
			</DropzoneComponent>
	  </React.Fragment>
	)
}
